import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import { localSave, localRead} from '@/libs/util'
import tools from './common/tools'

Vue.use(Vuex)
import common from './common/common.js'
export default new Vuex.Store({
  state: {
    crumbs: [],
    tabList:[{activeId: "0-1",fId: 0,fTitle: "平台首页1111",name: "平台首页1111",routeName: "home",routerUrl: "/"}],
    selectMenuItem:{activeId: "0-1",fId: 0,fTitle: "平台首页",name: "平台首页",routeName: "home",routerUrl: "/"},
    slideItem: '', // 当前选择的侧边栏
    uInfo: null, //登录用户个人信息
    selectId:'',//选择的id
    dealerToken:"",//选择一个经销商，接口所返回的token
    local:'',
    showLeftPx:true,
    showChildrenSide:false,
    langSet:false,
    TokenInvalidFlag:false,
    pageIdStore:null,
    wordListAll:[],
    wordListByPageId:[],
    formatTypeObj: {'1':'double','2':'enum','3':'bool','4':'text', '6':'date',
                '7':'Hex Numerical','8':'Hex Enumeration','9':'Hex Boolean','10':'Hex String', '11':'Hex Bitvalue',
                '12':'Hex Datetime','13':'struct','14':'Hex SNumerical','15':'float','16':'int32','17':'array'},
    timeFormateList:[
        {id: 'YYYY-MM-DD',val:"YYYY-MM-DD"},
        {id: 'YYYY-MM-DD HH-MM-SS',val:"YYYY-MM-DD HH-MM-SS"},
        {id: 'HH-MM-SS',val:"HH-MM-SS"},
        {id: 'HH-MM',val:"HH-MM"},
        {id: 'MM-SS',val:"MM-SS"},
        {id: 'MM-SS-MS',val:"MM-SS-MS"},
        {id: 'SS-MS',val:"SS-MS"},
    ]
  },
  mutations: {
    setLocal (state, lang) {
        localSave('local', lang.locale)
        // sessionStorage.setItem('local', lang.locale)
        // sessionStorage.setItem('langSet', lang.langSet)
        localSave('langSet', lang.langSet)
        state.langSet = lang.langSet
        state.local = lang.locale
    },
    setWordList(state, data){
        state.wordListAll = [...data]
        sessionStorage.setItem('wordListAll', JSON.stringify(data))
    },
    setwordListByPageId(state, data){
        state.wordListByPageId = [...data]
        sessionStorage.setItem('wordListByPageId', JSON.stringify(data))
    },
    setPageId(state, data){
        state.pageIdStore = data
        sessionStorage.setItem('pageId', data)
    },
    setShowLeft (state, data) {
        state.showLeftPx = data
    },
    setShowChildrenSide (state, data) {
        localSave('showChildrenSide', data)
        state.showChildrenSide = data
    },
    setSelectId (state, data) {
        common.encryptDataUinfo('select'+data+'id','myselectId','selectId')

        // localSave('selectId', data)
        state.selectId = data
    },
    setDealerToken (state, data) {
        state.dealerToken = data
        tools.setLocal('dealerToken',data)
    },
    setTokenInvalidFlag(state,data){
        state.TokenInvalidFlag = data
    },
    setTabMenuList(state, data) {
        sessionStorage.setItem('tabMenuList', JSON.stringify(data))
        state.tabList = data
    },
    setTabMenuItem(state, data) {
        sessionStorage.setItem('tabMenuItem', JSON.stringify(data))
        state.selectMenuItem = data
    },
    setSlideItem(state, data) {
        // console.log('data',data)
        sessionStorage.setItem('tabMenuItem', JSON.stringify(data))
        sessionStorage.setItem('_slideItem_', JSON.stringify(data))
        state.selectMenuItem = data //标签栏
        state.slideItem = data //侧边栏
       
        let offIndex1 = state.tabList.findIndex((mitem,index) => {
            return data.activeId == mitem.activeId
        })
  
        if(offIndex1<=-1){
            let items = {'activeId': data.activeId,'fId': data.fId,'fTitle': data.fTitle, 'name': data.sTitle,'routerUrl': data.routerUrl,'routeName':data.routeName}
            state.tabList.push(items)
            // mutations.setTabMenuList(state.tabList)
        }
        
    },
    set_uInfo(state, info) {
        state.uInfo = info
        sessionStorage.setItem('uInfo', JSON.stringify(info))
    },
    del_uInfo(state) {
		state.uInfo = ''
		sessionStorage.removeItem('uInfo')
	},
	
  },
  actions: {
  }
})
